import "isomorphic-fetch";

import memoizee from "memoizee";
import {useEffect, useState} from "react";
import {MsMap} from "src/constants/MsMap";

import {NEXT_PUBLIC_WORKER_URL} from "../publicEnv";

export type PricingTier = "tier1" | "tier2" | "tier3";

export type PricingTierItem = {
  name: string;
  price: number;
  slug: string;
  typ: string;
};

export type RegionPricing = Record<PricingTier, PricingTierItem[]>;

const pricingWorkerUrl = `${NEXT_PUBLIC_WORKER_URL}/pricing`;

export const fetchPricingData: () => Promise<RegionPricing> = memoizee(
  () =>
    fetch(pricingWorkerUrl)
      .then(res => res.json())
      .catch(() => {
        const tier1 = import("@data/localTier1Prices.json").then(module => module.default);
        const tier2 = import("@data/localTier2Prices.json").then(module => module.default);
        const tier3 = import("@data/localTier3Prices.json").then(module => module.default);

        return Promise.all([tier1, tier2, tier3]).then(res => {
          const [tier1, tier2, tier3] = res;
          return {
            tier1,
            tier2,
            tier3,
          };
        });
      }),
  {
    promise: true,
    maxAge: MsMap.ONE_MINUTE * 5,
  },
);

export const usePricingData = () => {
  const [pricingData, setPricingData] = useState<RegionPricing | null>(null);

  useEffect(() => {
    fetchPricingData().then(setPricingData);
  }, []);

  return pricingData;
};
